"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Utils - generators.
 * Helpful tools ::: generate random id (for client side), ...
 * @module utils/generators.js
 * @author @SurenAt93
 */

var generateRandomId = function generateRandomId(_) {
  return Date.now() + Math.random();
};

exports.generateRandomId = generateRandomId;